import { ChatFileMessage } from "context/adminContext";
import styles from "./index.module.css";
import { ChatFilesMessage } from "Components/ChatFiles/ChatFilesMessage";
import { formatMessageDateTime } from "helpers/format";

type Props = {
  key: string | number;
  messageId: number;
  messageCreatedAt: string;
  isFiles: boolean;
  content: ChatFileMessage[];
};

export const OtherMessage = ({ key, messageId, messageCreatedAt, content, isFiles }: Props) => {
  const isZ = messageCreatedAt.at(-1) === "Z";

  return (
    <div key={key} className={styles.systemMessageWrapper} id={`message-${messageId}`}>
      <div className={styles.messageDate}>{formatMessageDateTime(`${messageCreatedAt}${isZ ? "" : "Z"}`)}</div>
      <div className={styles.systemMessage}>{isFiles ? <ChatFilesMessage files={content} /> : content[0].content}</div>
    </div>
  );
};
